module.exports = __webpack_public_path__ + "static/media/kev-bitmoji-02.3147e0f3.png";